import * as PopoverPrimitive from "@radix-ui/react-popover";
import { useRouter } from "next/navigation";
import { FC } from "react";

import { useGetUserFeatureFlag } from "@/features/common/hooks";
import { DeleteAccountConfirmation } from "@/features/settings/modals";
import { Typography } from "@/shared/ui";
import { useUIStore } from "@/stores";
import { FeatureFlagEnum } from "@/types";
import { CookiesService } from "@/utils";

import { ConfirmLogout } from "../../onboarding-tabs/modals";

import styles from "./popover.module.scss";
import { MenuItem, PopoverProps } from "./popover.types";

const Popover: FC<PopoverProps> = ({ onClose }) => {
  const { replace } = useRouter();
  const { openModal } = useUIStore((state) => state.actions.modal);
  const { featureFlag: hiddenDeleteBtnFeatureFlag } = useGetUserFeatureFlag({
    name: FeatureFlagEnum.HIDDEN_DELETE_BUTTON,
  });

  const menu: MenuItem[] = [
    {
      label: "Logout",
      value: "logout",
      onClick: () =>
        openModal(ConfirmLogout, {
          onSubmit: () => {
            CookiesService.deleteAuthTokens();
            CookiesService.deleteUserStatus();
            CookiesService.deleteFinishedOnboardingToken();
            replace("/auth/login");
          },
        }),
    },
    {
      label: "Delete account",
      value: "delete-account",
      hidden: hiddenDeleteBtnFeatureFlag,
      onClick: () =>
        openModal(DeleteAccountConfirmation, {
          onSubmit: () => {
            CookiesService.deleteAuthTokens();
            CookiesService.deleteUserStatus();
            CookiesService.deleteFinishedOnboardingToken();
            replace("/auth/login");
          },
        }),
    },
  ];

  const clickItemHandler = (func: () => void) => {
    func();
    onClose();
  };

  return (
    <PopoverPrimitive.Content align={"end"} sideOffset={0} className={styles.popoverContainer}>
      {menu.map(({ value, hidden, label, onClick }) =>
        hidden ? null : (
          <button key={value} type="button" onClick={() => clickItemHandler(onClick)}>
            <Typography variant="subheadline">{label}</Typography>
          </button>
        )
      )}
    </PopoverPrimitive.Content>
  );
};

export { Popover };
